package com.narbase.letsgo.common

import com.narbase.letsgo.capacitor.CapacitorModule
import com.narbase.letsgo.web.routing.domain.appSettings.Platform

val platform by lazy { getPlatform() }

fun getPlatform(): Platform {
    val platformName = CapacitorModule.Capacitor.getPlatform()
    return Platform.values().firstOrNull { it.code == platformName }
        ?: throw NotImplementedError("Unknown platform: $platformName")
}